import { Component, ElementRef, EventEmitter, HostListener, inject, Input, Output, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatIconModule } from '@angular/material/icon';

export enum tooltipDirections {
  left = "left-0 top-0",
  top = "left-0 top-0",
  right = "left-0 top-0",
  bottom = "after:left-50% after:bottom-0",
}

@Component({
  selector: 'iho-pop-up',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule
  ],
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss'],
  animations: [
    trigger('popUpAnimation', [
      state('visible', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('visible <=> hidden', animate('300ms ease-in-out'))
    ])
  ]
})
export class PopUpComponent {

  renderer = inject(Renderer2);

  @ViewChild("popUpWrapper") popUpWrapper!: ElementRef;

  @Input() classList = "";
  @Input() isTooltip = false;
  @Input() isVisible = false
  @Input() manualPosition!: boolean;
  @Input() popUpTemplate!: TemplateRef<any>;
  @Input() Position!: string;
  @Input() right = 0;
  @Input() toolTipPosition!: string
  @Input() top = 0;

  @Output() closed = new EventEmitter<any>();
  @Output() isOnPopup = new EventEmitter<any>();

  @HostListener('mouseenter') onMouseEnter() {
    this.isOnPopup.emit(true)
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.isOnPopup.emit(false)
    this.closePopUp()
  }

  tooltipCaretDirections = tooltipDirections

  closePopUp() {
    this.closed.emit();
  }

}
